import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import PagedTable from '../PagedTable';
import { fetchUsers, removeUser } from '../../actions/reduxActions/organizations';
import Confirm from '../generic/confirm';
import translations from '../../translations';
import { stringReplace } from '../../utils/core';

/**
 * @description Flow Org. joined user list
 *
 * Display a list of users that have joined the organization.
 */
const JoinedUserList = ({ organizationUsers = [], fetchUsers, onRemoveUser }) => {

    const [showConfirmRemove, setShowConfirmRemove] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});

    const [page, setPage] = useState(1);
    const pageSize = 20;

    useEffect(() => {
        fetchUsers();
    }, []);

    const onRemoveClick = (user) => {
        setSelectedUser(user);
        setShowConfirmRemove(true);
    };

    const onRemoveConfirmClick = () => {
        onRemoveUser({ userId: selectedUser.id, email: selectedUser.email });
        setSelectedUser({});
        setShowConfirmRemove(false);
    };

    return (
        <>   
            <h4>Current Administrators</h4>         
            <PagedTable
                className="table margin-top"
                columns={[
                    {
                        renderHeader: () => 'Actions',
                        // cannot remove last user from an organization
                        renderCell: ({ item: user }) => organizationUsers.length === 1 ? null : (
                            <button className="btn-icon danger" onClick={() => onRemoveClick(user)}>
                                <span className="glyphicon glyphicon-trash" />
                            </button>
                        ),
                        size: '165px',
                    },
                    {
                        renderHeader: () => 'User',
                        renderCell: ({ item }) => (
                            <span title={`ID: ${item.id}`}>
                                {item.email} 
                            </span>
                        ),
                    },
                    {
                        renderHeader: () => 'Date Joined',
                        renderCell: ({ item }) => moment(item.addedAt).format('lll'),
                        size: '175px',
                    },
                ]}
                items={organizationUsers}
                page={page}
                pageSize={pageSize}
                onPageClick={setPage}
            />
            <Confirm
                show={showConfirmRemove}
                title={translations.FORG_remove_user_title}
                messages={[
                    stringReplace(translations.FORG_remove_user_message, { name: selectedUser.email }),
                ]}
                onConfirm={onRemoveConfirmClick}
                onCancel={() => setShowConfirmRemove(false)}
                buttonStyle="danger"
                buttonCaption="Remove"
            />
        </>
    );
};

const mapStateToProps = ({ organizationUsers }) => ({
    organizationUsers,
});

const mapDispatchToProps = {
    fetchUsers,
    onRemoveUser: removeUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(JoinedUserList);
